import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './WhatsAppTemplate.css'

const WhatsAppTemplatePageUI = ({ 
    context, 
    templates, 
    errorList, 
    loading, 
}) => {
    return (
        <SuperUserSettingsPageUI 
            context={context} 
            className='pg_su_whatsapp_template' 
            headerText='WhatsApp Template'
            centered={loading}
            page='whatsappTemplate'
        >
            {loading && <SpinnerComponentUI />}
            
            {errorList && errorList.length > 0 && (
                <GenericErrorUI error={errorList[0]} />
            )}

            {!loading && templates && templates.length === 0 && (
                <EmptyListUI
                    context={context}
                    className='g_m_top_200'
                    createDisabledMessageLabel='No templates available'
                />
            )}

            {!loading && templates && templates.length > 0 && (
                <div className="template-container">       
                    <div className="template-table">
                        <div className="template-table-header">
                            <div className="template-column template-name">
                                Template name
                            </div>
                            <div className="template-column template-category">
                                Category
                            </div>
                            <div className="template-column template-language">
                                Language
                            </div>
                            <div className="template-column template-status">
                                Status
                            </div>
                        </div>
                        
                        <div className="template-table-body">
                            {templates.map(template => (
                                <div className="template-row" key={template.whatsappTemplateId}>
                                    <div className="template-column template-name">
                                        {template.name}
                                    </div>
                                    <div className="template-column template-category">
                                        {template.category}
                                    </div>
                                    <div className="template-column template-language">
                                        {template.language}
                                        <div className="template-content">
                                            {template.content}
                                        </div>
                                    </div>
                                    <div className="template-column template-status">
                                        <span className={`status-badge ${template.status.toLowerCase()}`}>
                                            {template.status}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </SuperUserSettingsPageUI>
    )
}

export default WhatsAppTemplatePageUI
